import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpRequestService } from '../shared/services/http-request.service';
import * as myGlobals from '../shared/globalcontants';
import { SpoilageEntity } from '../shared/models/Transactions/SpoilageEntity';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class SpoilageService {
  public selectedItem: any;
  public isPackage = false;
  public isCopyNew = false;
  public selectedPackageItems: any = [];
  public baseUnits = ['Pounds', 'Kgs', 'Ltr'];
  public newSpoilageData: any = [];
  public newSpoilageSelectedData: any = [];
  public tableUnit = 'kgs';
  public isEditSpoilage = false;
  public editSpoilageTitle: string;
  public routeStack: any = ['/spoilage'];
  public spoilageReason = [{value: 1, viewValue: 'Broken package and fruits rotten'},
                          {value: 2, viewValue: 'Broken package and fruits rotten'},
    { value: 3, viewValue: 'Broken package and fruits rotten' }];
  public savedSpoilageTableData: any = [];
  public isNewSpoilage = false;
  public offlineIconShow = false;
  public spoilageFilter: any = [];
  public spoilageOfflineFilter: any = [];
  public newSpoilageFilter: any = [];
  public spoilageSort: any;
  public spoilageOfflineSort: any;
  public spoilageForm: any;
  public reqID: Number;
  public spoilageEntity: SpoilageEntity;
  public savedRequisitionTableData: any = [];
  public backOrderData: any = [];
  public spoilageFormData: FormGroup;
  InventotyLookupData: Array<any> = [];
  public spoilageOrderFormData: any = [];
  public isShowSaveChangeAlert = false;
  constructor(private _hs: HttpRequestService) { }
  getInventoryDetails(jsonPath) {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson[jsonPath]);
  }

  getRecentreacheditem(jsonPath) {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson[jsonPath]);
  }

  getOptionArray() {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson['inventoryList']);
  }

  getTransferItemDetails () {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson.getTransferDetails);
  }

  getPackageItem() {
    return this._hs.GetHttpRequest(myGlobals.LocalJsonUrl + myGlobals.LocalJson['packageItems']);
  }
}




